<script setup lang="ts">
    const props = defineProps({
        amount: Number,
    });
    const price = computed(() => props.amount?.toFixed());

    watch(
        () => props.amount,
        () => refreshAffirm(),
    );

    const refreshAffirm = async () => {
        if (import.meta.client && window.affirm) {
            await wait();
            window.affirm.ui.refresh();
        }
    };

    onMounted(() => {
        initAffirm();
    });
</script>
<template>
    <!-- 📘docs: https://docs.affirm.com/payments/docs/html-reference -->
    <p
        class="atm-affirm affirm-as-low-as"
        data-page-type="product"
        :data-amount="price"></p>
</template>

<style scoped>
    :deep(.affirm-modal-trigger) {
        @apply underline;
    }
</style>
